import React from 'react';
import c from 'classnames';
import s from './RootLayout.scss';

interface Props {
  left?: React.ReactNode;
  right?: React.ReactNode;
  prefix?: React.ReactNode;
  className?: string;
}

const RootLayout: React.FC<Props> = ({ prefix, left, right, className }) => (
  <div className={c(s['root'], className)}>
    <div className={s['left-with-prefix']}>
      {prefix && <div className={s['prefix']}>{prefix}</div>}
      {left && <div className={s['left']}>{left}</div>}
    </div>
    {right && <div className={s['right']}>{right}</div>}
  </div>
);
RootLayout.displayName = 'RootLayout';

export default RootLayout;
